import { HISTORY_ACTION_MODE } from '@candulabs/craft';
import React, { useEffect } from 'react';
import { Alert as StyleguideAlert } from 'styleguide';

import Node from 'craft/components/Node';
import { useEditor, useNodeContext } from 'craft/hooks';
import { AtomicText } from 'craft/resolvers/AtomicText';
import { Resolver, ToolboxComponentSections } from 'craft/types';

type Props = {
  title: string;
  description?: string;
  hasDescription?: boolean;
  intent?: string;
  outline?: string;
};

export const Alert: Resolver<Props> = ({ title, description, hasDescription, intent, outline }) => {
  const { id } = useNodeContext();
  const { actions } = useEditor();

  /* eslint-disable no-param-reassign */
  useEffect(() => {
    if (hasDescription) {
      if (description) {
        return;
      }
      actions.setProp(
        id,
        (props: Props) => {
          props.description = 'Description here';
        },
        HISTORY_ACTION_MODE.IGNORE,
      );
    } else {
      actions.setProp(
        id,
        (props: Props) => {
          delete props.description;
        },
        HISTORY_ACTION_MODE.IGNORE,
      );
    }
  }, [hasDescription]);
  /* eslint-enable no-param-reassign */

  return (
    <Node
      data-atomictext-node
      data-cy-props={outline}
      is={StyleguideAlert}
      intent={intent}
      message={
        description && (
          <AtomicText
            data-cy="node-alert-description"
            childrenString={description}
            propKey="description"
          />
        )
      }
      solid={outline === 'solid'}
    >
      <AtomicText data-cy="node-alert-title" childrenString={title} propKey="title" />
    </Node>
  );
};

Alert.craft = {
  name: 'Alert',
};

Alert.toolbox = {
  schema: {
    [ToolboxComponentSections.Layout]: {
      blockedDisplays: ['flex'],
    },
  },
};
